import { render } from "./PackageParticipants.vue?vue&type=template&id=6b0c0424&scoped=true"
import script from "./PackageParticipants.vue?vue&type=script&lang=js"
export * from "./PackageParticipants.vue?vue&type=script&lang=js"

import "./PackageParticipants.vue?vue&type=style&index=0&id=6b0c0424&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0c0424"]])

export default __exports__